export default {
  sideMenu:{
    "batch_server":"Batch Service",
    "custom_server": "Cust Service",
    "trans_authserver": "Auth Service",
    "clear_server": "Clearing and Settlement",
    "quota_server": "Limit Service",
    "amortized_server": "Installment and Loan",
    "operation_center": "Operation Center",
    "configuration_center": "Configration Center",
    "officialcard_server":"Corp Card Service",
    "openapi_server":"OPEN API Service",
    "base_server":"Base Service",
    "muse-nofn001":"Credit Card Service",
    "rule_server": "Risk Control",
    "approve_server": "Application Approval",
    "aps_server": "Incoming Application",
  }
}